import bus from "../bus";
import Cookies from "js-cookie";
import { FLASH } from "../action-types";

/**
 * Viewloader compatible class to allow server rendered and JS activated
 * flash messages coexist.
 * @param  {Element} el
 */
export default function ajaxFlash(el) {
  const flash = Cookies.get("_flash");
  if (flash != null) {
    const flashDetails = flash.split("|");
    bus.emit(FLASH, {
      type: flashDetails[0],
      message: flashDetails[1].replace(/\+/g, " ")
    });
    Cookies.remove("_flash", { path: "/" });
  } else {
    return false;
  }
}
